import type { TrafficScore } from '@ipfabric/utils';
import { useLocale } from 'containers/App/LocaleContext';
import { type FC, memo } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  trafficScore: TrafficScore;
}

const getProgressBarWidth = (dropped: number, total: number): number =>
  total > 0 ? Math.round((dropped / total) * 100) : 0;

const BarePacketDetailTrafficScore: FC<Props> = (props) => {
  const msg = useLocale();
  return (
    <div className='relative mx-5 pb-5'>
      <div className='text-lgu-lg mb-lgu-3 font-bold'>
        <FormattedMessage
          id='deviceView.trafficScore.title'
          defaultMessage={msg.deviceView.pathLookup.trafficScore.title}
          values={{
            total: props.trafficScore.total,
            dropped: props.trafficScore.dropped,
          }}
        />
      </div>
      <div className='device-view-packet-detail__traffic-score'>
        <div
          className='device-view-packet-detail__traffic-score-progress'
          style={{
            width: `${getProgressBarWidth(props.trafficScore.dropped, props.trafficScore.total)}%`,
          }}
        />
      </div>
    </div>
  );
};

export const PacketDetailTrafficScore = memo(BarePacketDetailTrafficScore);
